import { render, staticRenderFns } from "./index-activity.vue?vue&type=template&id=180cfc1a&scoped=true&"
import script from "./index-activity.vue?vue&type=script&lang=js&"
export * from "./index-activity.vue?vue&type=script&lang=js&"
import style0 from "./index-activity.vue?vue&type=style&index=0&id=180cfc1a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "180cfc1a",
  null
  
)

export default component.exports